"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Text = _interopRequireDefault(require("./Text"));

var _Textarea = _interopRequireDefault(require("./Textarea"));

var _Label = _interopRequireDefault(require("./Label"));

var _Group = _interopRequireDefault(require("./Group"));

var _Message = _interopRequireDefault(require("./Message"));

var _CheckBox = _interopRequireDefault(require("./CheckBox"));

var _Select = _interopRequireDefault(require("./Select"));

var _Rating = _interopRequireDefault(require("./Rating"));

var _Radio = _interopRequireDefault(require("./Radio"));

var _Button = _interopRequireDefault(require("./Button"));

var _Footer = _interopRequireDefault(require("./Footer"));

var _OTP = _interopRequireDefault(require("./OTP"));

require("../../assets/css/components/form.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// import Uploader from "./Uploader/index";
var Form = {
  Group: _Group["default"],
  Label: _Label["default"],
  Text: _Text["default"],
  Textarea: _Textarea["default"],
  Checkbox: _CheckBox["default"],
  Select: _Select["default"],
  Rating: _Rating["default"],
  Radio: _Radio["default"],
  Message: _Message["default"],
  Button: _Button["default"],
  Footer: _Footer["default"],
  OTP: _OTP["default"] // Uploader,

};
var _default = Form;
exports["default"] = _default;